exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.panel-head[data-v-5af18f5c]{padding:1rem\n}\n@media screen and (max-width: 39.9375em){\n.panel-head[data-v-5af18f5c]{padding:.5rem 1rem\n}\n}\nh2[data-v-5af18f5c]{margin-top:0\n}\n", ""]);




//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5af18f5c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"includePaths":["/home/runner/work/parks-rec-finder/parks-rec-finder/node_modules/foundation-sites/scss"]}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/home/runner/work/parks-rec-finder/parks-rec-finder/src/style/_variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/SearchResults.vue
// module id = 725
// module chunks = 0